import credit_platinum_old from "@assets/images/cards/card-image/credit_platinum_old.svg";
import credit_platinum_cashback from "@assets/images/cards/card-image/credit_platinum_cashback.svg";
import credit_platinum_shopping from "@assets/images/cards/card-image/credit_platinum_shopping.svg";
import credit_platinum_travel from "@assets/images/cards/card-image/credit_platinum_travel.svg";

import credit_mastercard_gold from "@assets/images/cards/card-image/credit_mastercard_gold.svg";
import credit_mastercard_class from "@assets/images/cards/card-image/credit_mastercard_class.svg";

import credit_standard_cashback from "@assets/images/cards/card-image/credit_standard_cashback.svg";
import credit_standard_shopping from "@assets/images/cards/card-image/credit_standard_shopping.svg";

import debit_local from "@assets/images/cards/card-image/debit_local.svg";
import debit_international from "@assets/images/cards/card-image/debit_international.svg";

const images: any = {
  credit_platinum_old,
  credit_platinum_cashback,
  credit_platinum_shopping,
  credit_platinum_travel,
  credit_mastercard_gold,
  credit_mastercard_class,
  credit_standard_cashback,
  credit_standard_shopping,
  debit_local,
  debit_international,
};

export default images;
